export default __webpack_public_path__ + "static/key-findings-figure-3-2025-3baa8e7ee8b892008fc691127701b161.png";